<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" class="row-space" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdfornecedor }}</div>
                </div>

                <div class="form-item-char20">
                    <label v-if="!ckCpfCnpjOk" class="label-link" @click="showModalCpfCnpj=true">CPF/CNPJ</label>
                    <label v-if="ckCpfCnpjOk" class="label-caption">CPF/CNPJ</label>
                    <div :class="{
                        'field-label-alert': !ckCpfCnpjOk,
                        'field-label': ckCpfCnpjOk,
                        'field-label-center': true}">{{ objEdicao.cpfcnpj }}</div>
                </div>

                <div class="form-item flexible">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmfornecedor" required maxlength="100" v-uppercase />
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">Inscrição Estadual</label>
                    <input type="text" class="input-center" v-model="edIe" v-number maxlength="11" />
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">CNAE</label>
                    <input type="text" class="input-center" v-model="edCnae" v-number maxlength="9" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item flexible">
                    <label class="label-caption">Endereço</label>
                    <input type="text" v-model="objEdicao.endereco" maxlength="100" v-uppercase />
                </div>
                <div class="form-item" style="flex: 0 0 150px;">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="objEdicao.complemento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <input type="text" v-model="objEdicao.bairro" maxlength="100" v-uppercase />
                </div>

                <div class="form-item">
                    <label class="label-caption">Município</label>
                    <input type="text" v-model="objEdicao.nmmunicipio" maxlength="100" v-uppercase />
                </div>

                <div class="form-item" style="flex: 0 0 70px;">
                    <label class="label-caption">UF</label>
                    <input type="text" v-model="objEdicao.uf" maxlength="2" v-uppercase />
                </div>

                <div class="form-item" style="flex: 0 0 100px;">
                    <label class="label-caption">CEP</label>
                    <input type="text" v-model="objEdicao.cep" v-cep maxlength="10" />
                </div>
            </div>


            <div class="row row-space">  
                <div class="form-item" style="flex: 0 0 160px;">
                    <label class="label-caption">Fone</label>
                    <input type="text" v-model="objEdicao.fone" v-phone maxlength="15" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Email</label>
                    <input type="email" v-model="objEdicao.email" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome Contato</label>
                    <input type="text" v-model="objEdicao.nmcontato" v-uppercase maxlength="100" />
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>

    <CpfCnpjModal
        v-if="showModalCpfCnpj"
        @close="showModalCpfCnpj = false"
        @cpfCnpjSubmitted="arrumarCpfCnpj"
    />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarFornecedor } from '@/models/Fornecedor';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import CpfCnpjModal from '@/components/modals/CpfCnpjModal.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close', 'salvo']);
const props=defineProps({
    idEdicao: {type: Number, default: 0},
    cpfCnpjNovo: {type: String, default: ''}});

const ckAtivo = ref(false);
const ckCpfCnpjOk= ref(true);
const edIe = ref(false);
const edCnae = ref(false);
const edNmEndereco = ref(null);
const objEdicao = criarFornecedor();
const isLoading = ref(false);
const msgAlerta = ref(null);
const showModalCpfCnpj = ref(false);

async function arrumarCpfCnpj(value){
    showModalCpfCnpj.value=false;
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const r = await Api.genericPut('/cad/fornecedor', {
            id: objEdicao.id,
            cpfcnpj: value, 
            idusuario: globalStore.idusuario});
        if (r.bolok == 1){objEdicao.cpfcnpj = value; ckCpfCnpjOk.value=true;}else{msgAlerta.value = r.error}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally {isLoading.value = false;}
}

const submitForm = async () => {
    try {
        isLoading.value=true;
        objEdicao.ckativo = ckAtivo.value ? 'S' : 'N';
        objEdicao.ie = Funcoes.integerFromString(edIe.value);
        objEdicao.cnae = Funcoes.integerFromString(edCnae.value);
        objEdicao.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        const response = await Api.genericPut('/cad/fornecedor', objEdicao);
        if (response.bolok==1){
            emit('salvo');
            emit('close');
        }
    } catch (error) {console.error('Error:', error);
    } finally {isLoading.value=false;}
}

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('fornecedor', props.idEdicao);
                Object.assign(objEdicao, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
            objEdicao.cpfcnpj = props.cpfCnpjNovo;
        }
        objEdicao.idusuario = globalStore.idusuario;
        ckAtivo.value       = objEdicao.ckativo==='S';
        edIe.value          = Funcoes.formatInteger(objEdicao.ie);
        edCnae.value        = Funcoes.formatInteger(objEdicao.cnae);
        edNmEndereco.value  = Funcoes.formatInteger(objEdicao.nmendereco);
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>